import {
  ICreateProductRequest,
  ICreateProductResponse,
  IDeleteByIdRequest,
  IDeleteProductResponse,
  IGetAllProductResponse,
  IGetByIdRequest,
  IGetProductByIdResponse,
  IGetProductPacking,
  IGetProductPackingResponse,
  IPaginationRequest,
  IUpdateProductPackingRequest,
  IUpdateProductRequest,
  IUpdateProductResponse,
} from "model";
import { PREFIX } from "utils/Const";
import { BaseApiService } from "./BaseApiService";

export const prefix = PREFIX.masterData;

const getUrl = (url: string) => {
  return `${prefix}/${url}`;
};
const URL_GET_ALL_PRODUCTS = getUrl("get-all-product");
const URL_GET_PRODUCT_PRODUCT_BY_ID = getUrl("get-product-by-id");
const URL_CREATE_PRODUCT = getUrl("create-product");
const URL_UPDATE_PRODUCT = getUrl("update-product");
const URL_DELETE_PRODUCT = getUrl("delete-product");
const URL_GET_PRODUCT_PACKING = getUrl("get-product-packing");
const URL_UPDATE_PRODUCT_PACKING = getUrl("update-product-packing");

class ProductApiService extends BaseApiService {
  public getAllProducts = (request: IPaginationRequest) =>
    this.get<IGetAllProductResponse>(URL_GET_ALL_PRODUCTS, {
      params: request,
    });
  public getProductById = (request: IGetByIdRequest) =>
    this.get<IGetProductByIdResponse>(URL_GET_PRODUCT_PRODUCT_BY_ID, {
      params: request,
    });
  public createProduct = (request: ICreateProductRequest) =>
    this.post<ICreateProductRequest, ICreateProductResponse>(
      URL_CREATE_PRODUCT,
      request
    );
  public updateProduct = (request: IUpdateProductRequest) =>
    this.put<IUpdateProductRequest, IUpdateProductResponse>(
      URL_UPDATE_PRODUCT,
      request
    );
  public deleteProduct = (request: IDeleteByIdRequest) =>
    this.delete<IDeleteProductResponse>(URL_DELETE_PRODUCT, {
      params: request,
    });

  public getProductPacking = (request: IGetProductPacking) =>
    this.get<IGetProductPackingResponse>(URL_GET_PRODUCT_PACKING, {
      params: request,
    });
  public updateProductPacking = (request: IUpdateProductPackingRequest) =>
    this.put<IUpdateProductPackingRequest, any>(
      URL_UPDATE_PRODUCT_PACKING,
      request
    );
}

export default new ProductApiService();
